import React from 'react'
import _ from 'lodash'
import FeatureContext from 'contexts/FeatureContext'
import hoistNonReactStatics from 'hoist-non-react-statics'
import forwardInnerRef from './forwardInnerRef'

const withFeatures = () => {
  return Component => {
    // eslint-disable-next-line react/require-render-return
    class WrappedComponent extends React.Component {
      render() {
        return (
          <FeatureContext.Consumer>
            {features => {
              const isFeatureEnabled = featurePath => {
                return _.get(features, featurePath, false) === true
              }
              return (
                <Component
                  {...this.props}
                  features={features}
                  isFeatureEnabled={isFeatureEnabled}
                />
              )
            }}
          </FeatureContext.Consumer>
        )
      }
    }

    WrappedComponent.displayName = `RFWithFeature(${Component.displayName})`
    hoistNonReactStatics(WrappedComponent, Component)

    return forwardInnerRef(WrappedComponent)
  }
}

export default withFeatures
